function getColorsColumnOptions(trialRow){
    let content = window.columnForTrial('color', trialRow);
    content =  content === "na" ? window.columnForTrial('textColor', trialRow) : content;
    if(content === "na"){
        return undefined;
    }
    /*
    Some examples of color specs:

    'blue' (which would make all elements mentioned above the text color blue)
    'fixation:blue' (would make only the fixation blue)
    'stim1:green;stim2:red;stim4:#FFFFFF;fixation:yellow' (stim 1 green, stim 2 red, stim 4 white, fixation yellow)

    */
    const regex = new RegExp(/(\w+\s*:\s*#?\w+)((\s*;\s*\w+\s*:\s*#?\w+)*)|(#?\w+)/gm);
    const matches = regex.exec(content);
    console.log(matches);
    var options = {};
    //only color
    if(matches[4]){
        options['color'] = matches[4];
    }
    //more than one option i.e fixation:blue;stim1:green
    else if(matches[1] && matches[1].length > 0){
        const splitMatches = matches[0].split(';');
        for(var i = 0; i < splitMatches.length; i++){
            var currentOption = splitMatches[i].split(':');
            if(currentOption.length < 1){
                continue;
            }
            options[currentOption[0]] = currentOption[1];
        }
    }

    return options;
}

function applyColorOptions(options){
    if(!options || !Object.keys(options).length){
        return;
    }
    
    for (var option in options){
        console.log('option', option);
        if(option == 'color'){
            document.body.style.color = options[option];
        }

        if(option == 'fixation'){
            const fixation =  document.getElementById('cross');
            fixation.style.color = options[option];
            //set fixation color
        }

        if(option.indexOf('stim') >= 0){
            const stimIndex = parseInt(option.substr(4));
            document.getElementById('word' + stimIndex).style.color = options[option];
            //set stimuli color
        }

        if(option == 'trialText'){
            document.getElementById('trialText').style.color = options[option];
            //set trialText color
        }

        if(option == 'feedback'){
            //set feedback color
        }
    }
}

function clearColorOptions(options){
    if(!options || !Object.keys(options).length){
        return;
    }

    for (var option in options){

        if(option == 'color'){
            document.body.style.color = textColor_setup;
        }

        if(option == 'fixation'){
            document.getElementById('cross').style.color = '';
            //set fixation color
        }

        if(option.indexOf('stim') >= 0){
            const stimIndex = parseInt(option.substr(4));
            document.getElementById('word' + stimIndex).style.color = '';
            //set stimuli color
        }

        if(option == 'trialText'){
            document.getElementById('trialText').style.color = '';
            //set trialText color
        }

        if(option == 'feedback'){
            //set feedback color
        }
    }
}